import { render, staticRenderFns } from "./LatestEventsTable.vue?vue&type=template&id=741247fe&scoped=true&"
import script from "./LatestEventsTable.vue?vue&type=script&lang=js&"
export * from "./LatestEventsTable.vue?vue&type=script&lang=js&"
import style0 from "./LatestEventsTable.vue?vue&type=style&index=0&id=741247fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741247fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
